var map = {
	"./AI-icon.webp": 6132,
	"./Agri-SCM Marketplace.webp": 9512,
	"./AnyConv.com__css-sprite-combined -full.webp": 5774,
	"./Deakin University.webp": 1059,
	"./add-activity-step-1@3x.webp": 3320,
	"./add-activity-step-2@3x.webp": 4388,
	"./add-activity-step-3-2.webp": 958,
	"./add-activity-step-3-2@2x.webp": 4775,
	"./add-activity-step-3-2@3x.webp": 7809,
	"./add-activity-step-3.webp": 6703,
	"./add-activity-step-3@2x.webp": 1215,
	"./add-activity-step-3@3x.webp": 6574,
	"./add-activity-step-5@3x.webp": 2099,
	"./ai.webp": 7044,
	"./ai@2x.webp": 1867,
	"./ai@3x.webp": 4072,
	"./bach-khoa-university.webp": 7458,
	"./bach-khoa-university@2x.webp": 4676,
	"./bach-khoa-university@3x.webp": 8037,
	"./big-data.webp": 9573,
	"./big-data@2x.webp": 3999,
	"./big-data@3x.webp": 832,
	"./blockchain-icon.webp": 4298,
	"./blockchain.webp": 1276,
	"./blockchain@2x.webp": 4768,
	"./blockchain@3x.webp": 8902,
	"./can-tho-university.webp": 3805,
	"./datascience-icon.webp": 3664,
	"./favicon.ico": 4329,
	"./features-iphone.webp": 4547,
	"./features-iphone@2x.webp": 4897,
	"./features-iphone@3x.webp": 7111,
	"./flinders-university.webp": 7969,
	"./flinders-university@2x.webp": 7614,
	"./flinders-university@3x.webp": 6844,
	"./free.webp": 9408,
	"./free@2x.webp": 1036,
	"./free@3x.webp": 2214,
	"./hero-circles2.webp": 6938,
	"./home.webp": 9568,
	"./home@2x.webp": 5533,
	"./home@3x.webp": 8489,
	"./icon-address.webp": 3073,
	"./icon-mail.webp": 8015,
	"./icon-phone.webp": 590,
	"./iot-icon.webp": 2271,
	"./iot.webp": 9242,
	"./iot@2x.webp": 1399,
	"./iot@3x.webp": 4084,
	"./iot_white.webp": 5592,
	"./iot_white@2x.webp": 7030,
	"./iot_white@3x.webp": 5791,
	"./logo-nav.webp": 5776,
	"./logo-nav@2x.webp": 4990,
	"./logo-nav@3x.webp": 4749,
	"./logo-tma.webp": 814,
	"./logo.webp": 7879,
	"./ncims.webp": 7794,
	"./public-api.webp": 2472,
	"./quick-data-collect.webp": 8790,
	"./report-chart.webp": 707,
	"./report.webp": 9627,
	"./shape-top-right-grey.webp": 7951,
	"./shape-top-right.webp": 5054,
	"./slider_01.webp": 8738,
	"./slider_02.webp": 2581,
	"./slider_03.webp": 2960,
	"./slider_04.webp": 3198,
	"./slu.webp": 6791,
	"./smart-insight.webp": 9313,
	"./tic-banner-1.webp": 1289,
	"./tic-banner-1@2x.webp": 5599,
	"./tic-banner-1@3x.webp": 1325,
	"./tracealliance.webp": 9973,
	"./university-of-adelaide.webp": 9088,
	"./university-of-oslo.webp": 4275,
	"./university-of-oslo@2x.webp": 6696,
	"./university-of-oslo@3x.webp": 9931,
	"./user-fiendly.webp": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;